import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="country-filter"
export default class extends Controller {
    static targets = ["input", "list", "noResults"]

    connect() {
        this.normalize = (str = "") =>
            String(str)
                .toLowerCase()
                .normalize("NFD")
                .replace(/[\u0300-\u036f]/g, "")

        // Cache mandatory field wrapper (by id, global)
        this.mandatoryFieldWrapper =
            document.getElementById("mandatory_field_wrapper")

        // small safety: if Stimulus hasn't bound inputTarget, try to find one inside the controller element
        if (!this.hasInputTarget) {
            this.inputTarget = this.element.querySelector(
                "input[type='text'], input"
            )
            if (!this.inputTarget) {
                console.error(
                    'country-filter: input target not found. Add data-country-filter-target="input".'
                )
                return
            }
        }

        // prepare fallback list lookup only if Stimulus didn't bind it
        if (!this.hasListTarget) {
            const lists = document.querySelectorAll(
                "[data-country-filter-target='list']"
            )
            if (lists.length === 0) {
                console.error(
                    'country-filter: no element found with data-country-filter-target="list"'
                )
            } else if (lists.length > 1) {
                console.warn(
                    "country-filter: multiple [data-country-filter-target='list'] elements found — falling back to the first one."
                )
            }
            this._fallbackList = lists[0] || null
        }

        // fallback noResults lookup if Stimulus didn't bind it
        if (!this.hasNoResultsTarget) {
            this._fallbackNoResults = document.querySelector(
                "[data-country-filter-target='noResults']"
            )
        }

        // if data-action didn't attach (rare), attach fallback listener
        if (!this.element.hasAttribute("data-action")) {
            this._fallbackHandler = () => this.filter()
            this.inputTarget.addEventListener("input", this._fallbackHandler)
        }
    }

    disconnect() {
        if (this._fallbackHandler && this.inputTarget) {
            this.inputTarget.removeEventListener("input", this._fallbackHandler)
        }
    }

    // called by data-action or fallback
    filter() {
        const raw = (
            this.hasInputTarget
                ? this.inputTarget.value
                : this.inputTarget
                    ? this.inputTarget.value
                    : ""
        ).trim()

        const query = this.normalize(raw)

        // prefer Stimulus-bound listTarget, otherwise fallback
        const container = this.hasListTarget ? this.listTarget : this._fallbackList
        if (!container) {
            console.error(
                'country-filter: missing list container. Ensure the list is inside the controller scope or present in the DOM with data-country-filter-target="list".'
            )
            return
        }

        const items = container.querySelectorAll(".country-item")
        let visibleCount = 0

        items.forEach((item) => {
            const nameAttr =
                item.dataset.countryName ||
                item.getAttribute("data-country-name") ||
                ""

            const name = this.normalize(nameAttr)
            const matches = query === "" ? true : name.includes(query)

            if (matches) {
                item.classList.remove("hidden")
                item.style.display = ""
                visibleCount++
            } else {
                item.classList.add("hidden")
            }
        })

        // --------------------------------------------------
        // noResults handling
        // --------------------------------------------------
        const noResultsEl = this.hasNoResultsTarget
            ? this.noResultsTarget
            : this._fallbackNoResults

        if (noResultsEl) {
            noResultsEl.classList.toggle("hidden", visibleCount !== 0)
        }

        // --------------------------------------------------
        // mandatory_field_wrapper handling (NEW)
        // --------------------------------------------------
        if (this.mandatoryFieldWrapper) {
            if (visibleCount === 0) {
                this.mandatoryFieldWrapper.classList.add("hidden")
            } else {
                this.mandatoryFieldWrapper.classList.remove("hidden")
            }
        }
    }
}
